import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=978ed996&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=978ed996&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978ed996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('978ed996')) {
      api.createRecord('978ed996', component.options)
    } else {
      api.reload('978ed996', component.options)
    }
    module.hot.accept("./DocumentPreview.vue?vue&type=template&id=978ed996&scoped=true", function () {
      api.rerender('978ed996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/DocumentPreview.vue"
export default component.exports